import classes from "./LanguageRadioGroup.scss";

class ReactRadioGroup extends React.Component {
  constructor() {
    super();
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.clickedOutside = false;
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // alert('You clicked outside of me!');
      this.clickedOutside = true;
    }else{
      this.clickedOutside = false;
    }
  }

  onBlurHandler(e){
    if(this.props.onBlur && this.clickedOutside) {
      this.props.onBlur(e);
    }
  }

  keyDownHandler(e){
    if (event.keyCode === 9) {
      this.clickedOutside = true;
    }
  }

  getRadioGroup = () => {
    let radioGroup = this.props.options.map((option, index) => {
      const isDisabled = typeof option==="object" ? option.isDisabled : false;
      option = typeof option==="object" ? option.value : option;
      let borderClass =
        this.props.validStyle.indexOf(option) > -1 ? classes.sceInputSuccess : null;
      let imageIcon =
        this.props.validStyle.indexOf(option) > -1
          ? "fas fa-check-circle fa-lg"
          : null;
      let checked =
        this.props.selectedOptions.indexOf(option) > -1
          ? (checked = this.props.selectedOptions)
          : null
          ;
      let sceRadiOutlineStyle =
        this.props.radioOutLineFlag.indexOf(option)>-1
          ? classes.sceRadiOutlineStyle
          : null;
      let tabIndexVal = index===0 ? 0 : -1;
      const innerClass = this.props.isRadioGrouptionDisabled ? classes.disableSceRadioButton : classes.sceRadioInner;
      return (
        <li onMouseDown={this.props.onMouseDown ? e => this.props.onMouseDown(e) : void(0)}>
          <label for={this.props.id}>
            <small className={[sceRadiOutlineStyle,classes.sceRadioTextSize].join(" ")}>{option}</small>
              {this.props.isRadioGrouptionDisabled ? 
              <input
                type="radio"
                name={this.props.setName}
                value={option}
                id={this.props.id}
                checked={checked}
                disabled
                aria-checked="false"
                aria-disabled="false"
                aria-invalid="false"
                tabIndex={tabIndexVal}
                onClick={(this.props.onClick) ? e => this.props.onClick(e) : void(0)}
                onBlur={this.onBlurHandler.bind(this)}
                onFocus={this.props.onFocus ? e =>this.props.onFocus(e) : void(0)}
              />
              :
                <input
                  type="radio"
                  name={this.props.setName}
                  value={option}
                  id={this.props.id}
                  checked={checked}
                  aria-checked="false"
                  aria-disabled="false"
                  aria-invalid="false"
                  aria-label={this.props.ariaLabel}
                  tabIndex={tabIndexVal}
                  onClick={(this.props.onClick) ? e => this.props.onClick(e) : void(0)}
                  onBlur={this.onBlurHandler.bind(this)}
                  onFocus={this.props.onFocus ? e =>this.props.onFocus(e) : void(0)}
                /> }
              <span />
          </label>
          {!_.isEmpty(this.props.caption) ? <div className={classes.sceDescPosition}>{this.props.caption}</div>: null}
        </li>
      );
    });
    return radioGroup;
  };


  render() {
    let radioGroup = this.getRadioGroup();
    return (
      <fieldset ref={this.setWrapperRef} onKeyDown={this.keyDownHandler.bind(this)}>
        <ul className={classes.sceFieldContainer}>
        {radioGroup}
        </ul>
      </fieldset>
    );
  }
}
export default ReactRadioGroup;
